<div class="updater">
  @if (processing()) {
    <xui-loading-bar></xui-loading-bar>
  }
  <div class="d-flex flex-column">
    <div class="files-list d-flex flex-row align-items-center justify-content-between">
      <div class="d-flex flex-column flex-grow-1">
        <mat-form-field class="w-100">
          <mat-label>File Name</mat-label>
          <input matInput [(ngModel)]="upload.fileName" required>
        </mat-form-field>
      </div>
      <mat-form-field class="ms-3">
        <mat-label>Document Date</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="documentDate" required>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <xui-tag-search class="w-50 ms-3" [searchObservable]="searchTags" [(tags)]="fileTags" (tagsChange)="onTagsChange($event)"></xui-tag-search>
    </div>
    <div class="total-upload-progress d-flex flex-row flex-nowrap align-items-center justify-content-end">
      <button mat-button color="primary" (click)="cancel()" [disabled]="processing()">Cancel</button>
      <button mat-flat-button color="primary" (click)="update()" [disabled]="processing()">Update</button>
    </div>
  </div>
</div>
